import { connect } from "react-redux";
import { getListDuNoGiaoNhanVien } from "actions/DuNoGiaoNhanVien";
import { DuNoGiaoNhanVien } from "components/BaoCao/DuNoGiaoNhanVien";

const mapStateToProps = (state) => ({
  DuNoGiaoNhanVien: state.DuNoGiaoNhanVien,
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
  getListDuNoGiaoNhanVien: (dataSearch) =>
    dispatch(getListDuNoGiaoNhanVien(dataSearch)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DuNoGiaoNhanVien);
